import {connect} from 'react-redux';
import CustomiseSidePanel from './CustomiseSidePanel';
import {checkIncluded, reindexedSections, sortedSections, sortSectionInReport} from '../ducks/reportSections';
import {makePreferences, updatePreferences} from '../actionCreators/preferences';
import {find} from 'lodash';
import AnalyticsGateway from '../lib/AnalyticsGateway';

const mappedSections = (sections, comparables) => {
  return sections.map((s) => {
    return {
      label: s.uiLabel,
      key: s.key,
      url: s.url,
      index: s.index,
      included: checkIncluded(s, comparables),
    };
  });
};

const mapStateToProps = (state, ownProps) => {
  const {
    reportSections,
    reportType: {value: reportTypeValue},
    featureFlags,
    comparableSales,
    comparableListings,
    comparableRentals,
  } = state;

  const sections = reportSections[reportTypeValue];

  return {
    sections:  mappedSections(sortedSections(sections), {comparableSales, comparableListings, comparableRentals}),
    featureFlags,
    reportType: reportTypeValue,
    propertyId: state.propertyDetail.propertyId,
    highlightedSection: ownProps.highlightedSection,
    onFocusSection: ownProps.onFocusSection,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSortEnd: (sections, reportType, oldIndex, newIndex, propertyId) => {
      if (oldIndex !== newIndex) {
        let changedSections = reindexedSections(sections, oldIndex, newIndex);
        dispatch(sortSectionInReport(reportType, oldIndex, newIndex));

        let preferences = {};
        changedSections.forEach(s => makePreferences(preferences, s.key, s.url, 'index', s.index));

        dispatch(updatePreferences(preferences, reportType));
        let movedSection = find(changedSections, (s) => s.index === newIndex);
        let sectionType = movedSection.key === 'CUSTOM' ? 'Custom PDF' : 'Default Section';
        AnalyticsGateway.sendEvent({
          eventName: 'Change Section Order',
          properties: [
            {label: 'Page', value: 'Customise'},
            {label: 'Property ID', value: propertyId},
            {label: 'Report Type', value: AnalyticsGateway.reportDescription(reportType)},
            {label: 'Section Type', value: sectionType},
            {label: 'Section Name', value: movedSection.label},
          ]
        });
      }
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSortEnd: (reportType, oldIndex, newIndex) => {
    dispatchProps.onSortEnd(stateProps.sections, reportType, oldIndex, newIndex, stateProps.propertyId);
  }
});



export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseSidePanel);
